'use client'

import * as React from 'react'
import { cn } from '@/lib/utils'

export function Accordion({ className, children }: { className?: string; children?: React.ReactNode }) {
  return <div className={cn('flex flex-col gap-4', className)}>{children}</div>
}

export function AccordionItem({
  value,
  defaultOpen = true,
  className,
  children,
}: {
  value: string
  defaultOpen?: boolean
  className?: string
  children?: React.ReactNode
}) {
  const [open, setOpen] = React.useState<boolean>(defaultOpen)
  return (
    <section className={cn('border rounded-md', className)} data-open={open}>
      <header
        className="px-4 py-3 border-b font-medium cursor-pointer select-none flex items-center justify-between"
        onClick={() => setOpen(o => !o)}
      >
        <span>{value}</span>
        <span className="text-muted-foreground text-xs">{open ? 'Hide' : 'Show'}</span>
      </header>
      {open && <div className="p-4">{children}</div>}
    </section>
  )
}


